import React from "react";
import { Route, Redirect } from "react-router-dom";
import AppRouteActionHandler from "./AppRouteActionHandler";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";
import * as sessionActions from "redux/actions/sessionActions";
import * as appStateActions from "redux/actions/appStateActions";

const AppRoute = ({ component: Component,
                    checkBosUserAuth, bosUserIsAuthenticated, 
                    ...rest }) => {

  return (
    <Route
      {...rest}
      render={props =>
        !checkBosUserAuth || bosUserIsAuthenticated === true ? (
          <AppRouteActionHandler {...rest}>
            <Component {...props} {...rest} />
          </AppRouteActionHandler>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              search: props.location.search,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

function mapStateToProps(state, ownProps) {
  return {
    bosUserIsAuthenticated: state.bosUser.isAuthenticated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch),
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppRoute);
